<div class="interim-container">
  <div class="loader"></div>
  <p>Loading...</p>
</div>
